import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import Units from "@/modules/settings/units";
import { UnitsType } from "@/types/settings/units";
import { Response } from "@/interface/response.interface";

const Unit = {
  namespaced: true,
  state: () => ({
    list: [],
    unit: {},
    success: false,
    message: "",
  }),
  getters: {
    list: (state: any) => state.list,
    unit: (state: any) => state.unit,
    success: (state: any) => state.success,
    message: (state: any) => state.message,
  },
  mutations: {
    SET_UNITS_LIST(state: any, payload: any) {
      state.list = payload.list;
    },

    SET_UNIT_RESULT(state: any, payload: any) {
      state.unit = payload.unit;
      state.success = payload.success;
      state.message = payload.message;
    },
  },
  actions: {
    /**
     * get units from api
     * @param commit
     * @param locations
     */
    async getUnits({ commit }: { commit: any }, { page = 1, itemsPerPage = 48 }) {
      return await request
        .get<Response<Array<UnitsType>>>(
          `${ENDPOINTS.UNITS}?page=${page}&page_size=${itemsPerPage}`
        )
        .then((response) => response.data)
        .then(async ({ data, count }) => {
          const list = data.map((item) => new Units(item));
          await commit("SET_UNITS_LIST", { list });
        })
        .catch(async (error) => {
          await commit("SET_UNITS_LIST", { list: [] });
          console.log(error);
        });
    },
    /**
     * create new Unit
     * @param commit
     * @param Unit
     */
    async createUnit({ commit }: { commit: any }, Unit) {
      return await request
        .post(`${ENDPOINTS.UNITS}`, Unit)
        .then((response) => response.data)
        .then(
          async ({ data }) =>
            await commit("SET_UNIT_RESULT", {
              unit: new Units(data),
              success: true,
              message: data.message || "",
            })
        )
        .catch(async (error) => {
          await commit("SET_UNIT_RESULT", { unit: null, success: false, message: error.message || "" });
          console.log(error);
        });
    },
    /**
     * update existing unit
     * @param commit
     * @param Unit
     */
    async updateUnit({ commit }: { commit: any }, Unit) {
      return await request
        .put(`${ENDPOINTS.UNITS}/${Unit.id}`, Unit)
        .then((response) => response.data)
        .then(
          async ({ data }) =>
            await commit("SET_UNIT_RESULT", {
              unit: new Units(data),
              success: true,
              message: data.message || "",
            })
        )
        .catch(async (error) => {
          await commit("SET_UNIT_RESULT", { unit: null, success: false, message: error.message || "" });
          console.log(error);
        });
    },
    /**
     * delete Unit using his id
     * @param commit
     * @param unitId
     */
    async deleteUnit({ commit }: { commit: any }, unitId) {
      return await request
        .delete(`${ENDPOINTS.UNITS}/${unitId}`)
        .then((response) => response.data)
        .catch(async (error) => {
          console.log(error);
        });
    },
  },
};

export default Unit;
